import Vue from 'vue'

import uiDropdownMenuItem from './src/ui-dropdown-menu-item.vue';
import uiDropdownMenuSub from './src/ui-dropdown-menu-sub.vue';
import uiDropdownMenu from './src/ui-dropdown-menu.vue';

var components = [
  uiDropdownMenuItem,
  uiDropdownMenuSub,
  uiDropdownMenu
];

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/dropdown-menu/index.js
// module id = 401
// module chunks = 0